// Coverage line REST client — FE-SCRM-015.
//
// Wraps BE-SCRM-006's CRUD endpoints under ``/api/v1/sales/``. All
// requests ride the X-Entity-Id header via the shared ``api`` client;
// tenant isolation lands at the backend gate.

import { api } from "@/api/client";

import type {
  AddCoverageLineInput,
  CoverageLine,
  CoverageLineListResponse,
  UpdateCoverageLineInput,
} from "./types";


export function fetchCoverageLines(
  opportunityId: string,
  opts?: { signal?: AbortSignal },
): Promise<CoverageLineListResponse> {
  return api.get<CoverageLineListResponse>(
    `/api/v1/sales/opportunities/${encodeURIComponent(opportunityId)}/coverage-lines`,
    opts,
  );
}


export function addCoverageLine(
  opportunityId: string, input: AddCoverageLineInput,
): Promise<CoverageLine> {
  return api.post<CoverageLine>(
    `/api/v1/sales/opportunities/${encodeURIComponent(opportunityId)}/coverage-lines`,
    input,
  );
}


export function updateCoverageLine(
  coverageLineId: string, input: UpdateCoverageLineInput,
): Promise<CoverageLine> {
  return api.patch<CoverageLine>(
    `/api/v1/sales/coverage-lines/${encodeURIComponent(coverageLineId)}`,
    input,
  );
}


export function deleteCoverageLine(
  coverageLineId: string,
): Promise<{ deleted: boolean }> {
  return api.delete<{ deleted: boolean }>(
    `/api/v1/sales/coverage-lines/${encodeURIComponent(coverageLineId)}`,
  );
}
